import { PageDivider } from "./PageDivider";

export default PageDivider;
export { PageDivider };
